const classe = new Map();

const label = new Map();

classe.set('EM_PROCESSAMENTO', 'em-processamento');
classe.set('PROCESSADO', 'processado');
classe.set('NA_FILA', 'na-fila');
classe.set('CANCELADO', 'cancelado');
classe.set('FALHA_PROCESSAMENTO', 'falha-processamento');

label.set('EM_PROCESSAMENTO', 'mensagens.laudos.emProcessamento');
label.set('PROCESSADO', 'mensagens.laudos.processado');
label.set('NA_FILA', 'mensagens.laudos.naFila');
label.set('CANCELADO', 'mensagens.laudos.cancelado');
label.set('FALHA_PROCESSAMENTO', 'mensagens.laudos.falhaNoProcessamento');

export { classe, label };
